import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import { toUrlSafeDate } from "Utils/dateHelpers";

import { addPlanToCart } from "Common/CartService";

import makeBem from "Utils/makeBem";

const bem = makeBem("EffectiveDateChanger");

const EffectiveDateChangerDumb = ({ nextQuarterPricingAvailable, companyProfile, handleRemovePlans }) => {
  if (nextQuarterPricingAvailable) {
    return (
      <div className="EffectiveDateChanger__wrapper">
        {companyProfile && (
          <div className={classnames(bem(), bem(null, isIntuit() && "intuit"))}>
            {`You are currently seeing the prices for ${companyProfile.target_effective_date}.`}
            <a
              onClick={() => {
                handleRemovePlans();
              }}
              href={`/small-group/update-target-effective-date?company_id_token=${companyProfile.id_token}&target_effective_date=${toUrlSafeDate(
                marketDateToSwitchTo(companyProfile),
              )}`}
              style={{ marginLeft: "10px" }}
            >
              {`Click here to see prices for ${marketDateToSwitchTo(companyProfile).toLocaleString("en-us", {
                month: "long",
                year: "numeric",
                day: "numeric",
              })}`}
            </a>
          </div>
        )}
      </div>
    );
  }
  return null;
};

const mapStateToProps = (state) => ({
  companyProfile: state.companyProfile,
  nextQuarterPricingAvailable: state.nextQuarterPricingAvailable,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  handleRemovePlans: () => {
    dispatch(addPlanToCart({ planType: "medical", plan: null }));
    dispatch(addPlanToCart({ planType: "dental", plan: null }));
    dispatch(addPlanToCart({ planType: "vision", plan: null }));
    AnalyticsTracking.trackEvent("plan_removed", {
      location: "effective_date_changer",
      type: "all",
      deprecatedName: `remove-plan/all`,
    });
  },
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(EffectiveDateChangerDumb);

const marketDateToSwitchTo = (companyProfile) => {
  const companyProfileDate = new Date(companyProfile.target_effective_date);
  const nextEffectiveDate = new Date(companyProfile.next_effective_date);
  const nextMarketEffectiveDate = new Date(companyProfile.next_market_effective_date);

  if (companyProfileDate > nextEffectiveDate) {
    return nextEffectiveDate;
  }
  return nextMarketEffectiveDate;
};
